export default __webpack_public_path__ + "static/media/azure.aaddccf6.png";